import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';

import { entitlementStatementsTranslationKeys } from '../../../translations';

const StyledTooltipText = styled.div`
   text-align: left;
`;

StyledTooltipText.displayName = 'StyledTooltipText';

export const TooltipText = (): JSX.Element => (
   <StyledTooltipText>
      <Translate>{entitlementStatementsTranslationKeys.createModal.grantingDateTooltip}</Translate>
   </StyledTooltipText>
);
